import { Outlet, Link, useLocation } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";

export default function Layout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const [title, setTitle] = useState("Regulasi Analyzer");

  useEffect(() => {
    const h = localStorage.getItem("session:title");
    if (h) setTitle(h);
  }, []);

  const nav = [
    { label: "Dashboard", path: "/" },
    { label: "Regulasi", path: "/regulations" },
    { label: "Tracing", path: "/trace" },
    { label: "Topik", path: "/topics" },
  ] as const;

  return (
    <div className="min-h-screen bg-bg text-text">
      <header className="sticky top-0 z-20 border-b border-border bg-surface">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6">
          <div className="flex items-center gap-3">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-white">
              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75L18 6m0 0l3 3m-3-3l-3 3M6.75 18.75L9 21m0 0l3-3m-3 3l3 3M6.75 6L9 3m0 0l3 3m-3-3l-3 3" />
              </svg>
            </span>
            <h1 className="text-lg font-semibold text-text">{title}</h1>
          </div>
          <nav className="flex gap-1 overflow-x-auto px-2">
            {nav.map((n) => (
              <Link
                key={n.path}
                to={n.path}
                className={`flex items-center gap-1 rounded px-3 py-1.5 text-sm font-medium transition ${
                  location.pathname === n.path
                    ? "bg-primary-500 text-white"
                    : "text-muted hover:bg-primary-500 hover:text-white"
                }`}
              >
                {n.label}
              </Link>
            ))}
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6">{children}</main>
      <footer className="mt-8 border-t border-border text-center text-xs text-muted">
        Regulasi Analyzer — tracing & versioning peraturan Indonesia sejak 1945
      </footer>
    </div>
  );
}
